import { PropsWithChildren } from 'react';
import { cn } from '@shadcn/utils';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

export const AppLink = ({ to, className, ...restProps }: PropsWithChildren<{}> & LinkProps) => {
  return <RouterLink className={cn('text-primary-foreground underline', className)} to={to} {...restProps} />;
};
